import { createAction } from 'redux-act';

import MenuCategoriesData from '../../../models/MenuCategoriesData';

export interface SaveMenuCategoriesPayload {
  data: MenuCategoriesData[];
}

export const saveMenuCategories = createAction<SaveMenuCategoriesPayload>('SAVE_MENUCATEGORIES');

export interface MenuCategoriesSaveSucceededPayload {
  data: MenuCategoriesData[];
}
export const menucategoriesSaveSucceeded = createAction<MenuCategoriesSaveSucceededPayload>('MENUCATEGORIES_SAVE_SUCCEEDED');

export const menucategoriesSaveFailed = createAction<object>('MENUCATEGORIES_SAVE_FAILED');
